/**
 * Application configuration
 * Actual values come from backend-provided data
 */
export const fromSerializedJson = (domId) => {
  const element = document.getElementById(domId);
  const json = element && element.dataset.config;
  return json ? (JSON.parse(json)) : undefined;
};
